// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__vNBEP","clinicsSelect":"TableHeading_clinicsSelect__zNKYU"};